var FeaturedcontentView,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

FeaturedcontentView = (function() {
  function FeaturedcontentView(section, load_data) {
    this.section = section;
    if (load_data == null) {
      load_data = true;
    }
    this.edit_fc = __bind(this.edit_fc, this);
    this.delete_fc = __bind(this.delete_fc, this);
    this.add_fc = __bind(this.add_fc, this);
    this.load = __bind(this.load, this);
    this.refresh = __bind(this.refresh, this);
    this.move = __bind(this.move, this);
    ObservableArray(this, 'fcs');
    Observable(this, 'loaded', null);
    Observable(this, 'title_editor');
    Observable(this, 'content_editor');
    $('#fc_title').bind('keydown', 'return', this.add_fc);
    if (load_data != null) {
      this.load();
    }
  }

  FeaturedcontentView.prototype.move = function(element) {
    var fc, to;
    fc = element.item;
    to = element.targetIndex;
    return fc.update({
      sort: to
    });
  };

  FeaturedcontentView.prototype.refresh = function() {
    return this.loaded(null);
  };

  FeaturedcontentView.prototype.load = function() {
    return Featuredcontent.find(this.section, {}, (function(_this) {
      return function(data) {
        var fc, _i, _len, _results;
        _results = [];
        for (_i = 0, _len = data.length; _i < _len; _i++) {
          fc = data[_i];
          _results.push(_this.fcs.push(Featuredcontent(fc)));
        }
        return _results;
      };
    })(this));
  };

  FeaturedcontentView.prototype.add_fc = function(data, event) {
    var external_id, type;
    type = $(data.type).val();
    external_id = $(data.external_id).val();
    if ('' === type) {
      return;
    }
    return Featuredcontent.create({
      section: this.section,
      type: type,
      external_id: external_id
    }, (function(_this) {
      return function(data) {
        return _this.fcs.unshift(Featuredcontent(data));
      };
    })(this));
  };

  FeaturedcontentView.prototype.delete_fc = function(fc) {
    if (confirm('Are you sure you want to unfeature this content?')) {
      return fc["delete"]((function(_this) {
        return function() {
          return _this.fcs.remove(fc);
        };
      })(this));
    }
  };

  FeaturedcontentView.prototype.edit_fc = function(fc, e) {
    e = $(e.target).parent().parent().parent();
    this.title_editor(new MediumEditor(e.find('h3'), {
      disableToolbar: true,
      disableReturn: true,
      placeholder: 'Title',
      firstHeader: 'h1'
    }));
    return this.content_editor(new MediumEditor(e.find('.article-preview-text'), {
      disableToolbar: true,
      disableReturn: true,
      placeholder: 'Content'
    }));
  };

  return FeaturedcontentView;

})();

//# sourceMappingURL=featuredcontent.js.map
